import { lazy } from "react";

export const PartnersHome = lazy(() => import("./PartnersHome"));
export const SalaryManagement = lazy(() => import("./SalaryManagement"));
export const WelfareManagement = lazy(() => import("./WelfareManagement"));
export const JobPostingManagement = lazy(() => import("./JobPostingManagement"));
export const ApplicantManagement = lazy(() => import("./ApplicantManagement"));
export const OperatorManagement = lazy(() => import("./OperatorManagement"));
export const NoAccessManagement = lazy(() => import("./NoAccessManagement"));
